import { render, staticRenderFns } from "./PartnerNav.vue?vue&type=template&id=60a94662&scoped=true"
import script from "./PartnerNav.vue?vue&type=script&lang=js"
export * from "./PartnerNav.vue?vue&type=script&lang=js"
import style0 from "./PartnerNav.vue?vue&type=style&index=0&id=60a94662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a94662",
  null
  
)

export default component.exports